export default __webpack_public_path__ + "static/media/NotoSans-Regular.8b33906a.eot";